<template>
    <el-form-item prop="scheduledGates" class="py-1">
        <div class="text-left">
            <strong
                class="text-white body-2"
                v-text="schedule.Description"
            ></strong>
        </div>
        <v-select
            :items="gates"
            :label="$t('form.label.selectGate')"
            v-model="enabledGates"
            item-value="Name"
            item-text="Name"
            return-object
            clearable
            multiple
            required
            chips
            dark
        >
        </v-select>
    </el-form-item>
</template>

<script>
export default {
    name: 'scheduled-gate-access',

    props: ['gates', 'schedule', 'scheduledGates'],

    data() {
        return {
            enabledGates: this.scheduledGates || [],
        }
    },

    watch: {
        enabledGates() {
            this.$emit('gates-scheduled', {
                schedule: this.schedule,
                gates: this.enabledGates,
            })
        },
    },
}
</script>
